import { render, staticRenderFns } from "./FooterContainer.vue?vue&type=template&id=60ebab99&scoped=true&"
import script from "./FooterContainer.vue?vue&type=script&lang=js&"
export * from "./FooterContainer.vue?vue&type=script&lang=js&"
import style0 from "./FooterContainer.vue?vue&type=style&index=0&id=60ebab99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ebab99",
  null
  
)

export default component.exports